import React from "react"
import { Redirect } from "react-router-dom"




// Pages Calendar
import Calendar from "../pages/Calendar/index"

// Pages Evenement
import ListeEvenement from "../pages/Evenement/ListeEvenement"
import AjoutEvenement from "../pages/Evenement/AjoutEvenement"
import DetailEvenement from "../pages/Evenement/DetailEvenement"

// User profile
import UserProfile from "../pages/Authentication/UserProfile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import profile from "../pages/Authentication/Profile"

// Dashboard
import Acceuil from "../pages/Dashboard/index"

// Charts
import ChartApex from "../pages/Charts/Apexcharts"
import ChartistChart from "../pages/Charts/ChartistChart"
import ChartjsChart from "../pages/Charts/ChartjsChart"
import EChart from "../pages/Charts/EChart"
import SparklineChart from "../pages/Charts/SparklineChart"
import ToastUIChart from "../pages/Charts/ToastUIChart"
import ChartsKnob from "../pages/Charts/charts-knob"

//Reporting
import Reporting from "../pages/Reporting/Reporting"

//Ressource
import AddRessource from "../pages/Ressources/AddRessource"
import DetailRessource from "../pages/Ressources/DetailRessource"
import ListeRessource from "../pages/Ressources/ListeRessource"
import ModifierRessource from "../pages/Ressources/ModifierRessource"

//calendar
import liste from "../pages/Calendar/liste"

// Experts
import ListeExpert from "../pages/Experts/ListeExpert"
import AjoutExpert from "../pages/Experts/AjoutExpert"
import DetailExpert from "../pages/Experts/DetailExpert"


const authProtectedRoutes = [
  { path: "/accueil", component: Acceuil },

  //profile
  // { path: "/profile", component: UserProfile },

  //Calendrier
  { path: "/calendar", component: Calendar },

  //Evenement
  { path: "/liste-evenement", component: ListeEvenement },
  { path: "/ajout-evenement", component: AjoutEvenement },
  { path: "/detail-evenement", component: DetailEvenement },

  //Charts
  { path: "/apex-charts", component: ChartApex },
  { path: "/chartist-charts", component: ChartistChart },
  { path: "/chartjs-charts", component: ChartjsChart },
  { path: "/e-charts", component: EChart },
  { path: "/sparkline-charts", component: SparklineChart },
  { path: "/tui-charts", component: ToastUIChart },
  { path: "/charts-knob", component: ChartsKnob },

  //Reporting
  { path: "/reporting", component: Reporting },

  //Ressources
  { path: "/ajout-ressource", component: AddRessource },
  { path: "/detail-ressource", component: DetailRessource },
  { path: "/liste-ressource", component: ListeRessource },
  { path: "/modifier-ressource", component: ModifierRessource },

  //calendar
  { path: "/liste-calendar", component: liste },

  //Expert
  { path: "/liste-expert", component: ListeExpert },
  { path: "/ajout-expert", component: AjoutExpert },
  { path: "/detail-expert", component: DetailExpert },

  //profile
  { path: "/profile", component: profile },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/accueil" /> },

]

const publicRoutes = [
  
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },

]

export { authProtectedRoutes, publicRoutes }
